export default __webpack_public_path__ + "static/media/Advisor-logoblue-25.40d42c6c.png";